import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Renders the listing description with read-more behavior, plus a "show
 * original / show translation" toggle when a translation is available.
 *
 * Translation props (all optional; omitted when the viewer's language matches
 * the listing's original language):
 *   - translation: { name, description } | null
 *   - showOriginal: boolean
 *   - onToggleOriginal: () => void
 *   - translationReady: boolean
 */
export default function ProductDescription({
  description,
  showReadMore,
  expanded,
  onToggle,
  translation,
  showOriginal,
  onToggleOriginal,
  translationReady,
}) {
  const { t } = useTranslation();
  const text = description || '';
  const short = text.length > 200 ? text.slice(0, 200) + '...' : text;
  const hasTranslation = Boolean(translation && (translation.name || translation.description));
  const canToggle = hasTranslation && translationReady;

  return (
    <div className="productDescription">
      <p className="p-bold">{t('productView.description')}</p>
      <p>
        {expanded || !showReadMore ? text : short}
        {showReadMore && (
          <button type="button" className="viewReadMore" onClick={onToggle}>
            {expanded ? '' : ' Read more'}
          </button>
        )}
      </p>
      {canToggle && (
        <button
          type="button"
          className="translationToggle"
          onClick={onToggleOriginal}
          aria-pressed={showOriginal}
        >
          {showOriginal
            ? t('productView.showTranslation')
            : t('productView.showOriginal')}
        </button>
      )}
    </div>
  );
}
